// extracted by mini-css-extract-plugin
module.exports = {"style":"_21vwCslfsdzgF0J7Je3ofj","userInfoStyle":"_19GGeT1faW7T_a70pqa20J","whiteBoxView":"_3lnyt4oPSMExvtEJ4YrxFA","confirmPopupStyle":"Dql6L-8o8TPKo_XlvWIzo"};